import React from "react";
import { motion } from "framer-motion";
import { BADGES } from "../data/modules";
import { useProgress } from "../context/ProgressContext";
import { PassportBadge } from "../components/PassportBadge";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Badges() {
  const { progress } = useProgress();
  const earned = progress.badges || [];
  const earnedCount = BADGES.filter((b) => earned.includes(b.id)).length;

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 md:py-16">
      <Link to="/" className="inline-flex items-center gap-2 font-mono-code text-xs uppercase tracking-widest text-muted-foreground hover:text-primary mb-6">
        <ArrowLeft className="w-4 h-4" /> back
      </Link>
      <div className="flex items-baseline justify-between mb-10">
        <h1 className="font-serif-display text-5xl md:text-6xl">Passport</h1>
        <div className="font-mono-code text-xs text-muted-foreground">
          {earnedCount}/{BADGES.length} STAMPS
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-testid="badges-grid">
        {BADGES.map((b, i) => {
          const isEarned = earned.includes(b.id);
          return (
            <motion.div
              key={b.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.05 * i }}
              className="border border-border bg-surface p-8 flex flex-col items-center text-center"
              data-testid={`badge-${b.id}`}
            >
              <PassportBadge label={b.label} sub="PROMPT CRAFT" earned={isEarned} size={110} />
              <div className="font-serif-display text-xl mt-6">{b.label}</div>
              <div className="text-sm text-muted-foreground mt-2 leading-relaxed">{b.desc}</div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
